export const users = [{
    name: 'John',
    attendances: '38%',
    average: '2.8'
}, {
    name: 'Artur',
    attendances: '58%',
    average: '2.3'
}, {
    name: 'Michał',
    attendances: '88%',
    average: '3.8'
}, {
    name: 'Bartek',
    average: '5.0'
}, {
    name: 'Andrzej',
    attendances: '48%',
    average: '1.2'
}, {
    name: 'Romek',
    average: '3.0'
}];